module.exports = __webpack_public_path__ + "static/img/SketchPng1388a6ad401e56a8892faf19349d639dfc130ffa594a39d516538bdf38b2da80.34742b36.png";